import React from 'react';
import {
  Inventory2,
  Hiking,
  HealthAndSafety,
  Description,
  Dashboard,
  Search,
  Settings,
  WorkOutline,
  MenuBook,
  ChecklistRtl,
  Badge,
  Straighten,
  StorefrontOutlined,
  ReceiptLongOutlined,
  Book,
  ShoppingCart,
  SwapHoriz,
  Assessment,
  Undo,
  Assignment,
  Report,
  Warning,
  Inventory,
  Build,
  Refresh,
  LocalShipping,
  CheckCircle,
  Storefront,
  Person,
  LocationOn,
  AdminPanelSettings,
  ManageAccounts,
  History,
  Upload,
  Analytics,
  Layers,
  Rule,
  ScheduleSend,
  ShoppingCartCheckout,
  QrCode2,
  MonitorHeart,
} from '@mui/icons-material';

const registry: Record<string, React.ReactElement> = {
  Inventory2: <Inventory2 />,
  Hiking: <Hiking />,
  HealthAndSafety: <HealthAndSafety />,
  Description: <Description />,
  Dashboard: <Dashboard />,
  Search: <Search />,
  Settings: <Settings />,
  WorkOutline: <WorkOutline />,
  MenuBook: <MenuBook />,
  ChecklistRtl: <ChecklistRtl />,
  Badge: <Badge />,
  Straighten: <Straighten />,
  'storefront-outline': <StorefrontOutlined />,
  ReceiptLongOutlined: <ReceiptLongOutlined />,
  // Navigation icons from 143-ui-navigation-config.sql
  Book: <Book />,
  ShoppingCart: <ShoppingCart />,
  ShoppingCartCheckout: <ShoppingCartCheckout />,
  SwapHoriz: <SwapHoriz />,
  Assessment: <Assessment />,
  Undo: <Undo />,
  Assignment: <Assignment />,
  Report: <Report />,
  Warning: <Warning />,
  Receipt: <ReceiptLongOutlined />,
  Inventory: <Inventory />,
  Build: <Build />,
  Refresh: <Refresh />,
  LocalShipping: <LocalShipping />,
  CheckCircle: <CheckCircle />,
  Storefront: <Storefront />,
  Person: <Person />,
  LocationOn: <LocationOn />,
  AdminPanelSettings: <AdminPanelSettings />,
  ManageAccounts: <ManageAccounts />,
  History: <History />,
  Upload: <Upload />,
  Analytics: <Analytics />,
  Layers: <Layers />,
  Rule: <Rule />,
  ScheduleSend: <ScheduleSend />,
  QrCode2: <QrCode2 />,
  MonitorHeart: <MonitorHeart />,
};

export function resolveIcon(name?: string, fallback: React.ReactElement = <Description />) {
  if (!name) return fallback;
  return registry[name] ?? fallback;
}

export const defaultIcons = {
  group: <Inventory2 />,
  leaf: <Description />,
  dashboard: <Dashboard />,
  search: <Search />,
  settings: <Settings />,
};
